import Config from '@/config';
import { SupplyTaskListResult } from '@/types/api/supplyTask';
import http, { HttpPromise } from './http';

const list = (role: string, params?: SupplyTaskListResult): HttpPromise<SupplyTaskListResult> => http.get<SupplyTaskListResult>(`${Config.apiHost}/${role}/supplyTask/list/`, { params });
const details = (role: string, params?: SupplyTaskListResult): HttpPromise<SupplyTaskListResult> => http.get<SupplyTaskListResult>(`${Config.apiHost}/${role}/supplyTask/detail/`, { params });

export default {
  save: async (params) => http.post(`${Config.apiHost}/supplier/supplyTask/save/`, params),
  changeStatusOnProcessedByReviewer: async (params) => http.post(`${Config.apiHost}/customer/supplyTask/status/changeStatusOnProcessedByReviewer/`, params),
  changeStatusOnCancel: async (params) => http.post(`${Config.apiHost}/customer/supplyTask/status/changeStatusOnCancel/`, params),
  supplier: {
    list: list.bind(this, 'supplier'),
    details: details.bind(this, 'supplier'),
  },
  customer: {
    list: list.bind(this, 'customer'),
    details: details.bind(this, 'customer'),
  },
  administrator: {
    list: list.bind(this, 'customer'),
    details: details.bind(this, 'customer'),
  },
};
